<script>
import BrandLayout from "@/Layouts/BrandLayout.vue";

export default {
    layout: BrandLayout,
};
</script>

<script setup>
import { Head } from "@inertiajs/vue3";
import HeroSection from "@/Components/Brand/sections/HeroSection.vue";
import FeaturedLogos from "@/Components/Brand/sections/FeaturedLogos.vue";
import InspirationExperts from "@/Components/Brand/sections/InspirationExperts.vue";
import GiftingMadeSimple from "@/Components/Brand/sections/GiftingMadeSimple.vue";
import CtaPair from "@/Components/Brand/sections/CtaPair.vue";
import UltimateHeroCloser from "@/Components/Brand/sections/UltimateHeroCloser.vue";

defineProps({
    expertLists: {
        type: Array,
        default: () => [],
    },
    expertListTabs: {
        type: Array,
        default: () => [],
    },
});
</script>

<template>
    <div>
        <Head title="Home" />

        <HeroSection />

        <!--
            Shared purple panel (#63009c) behind the featured logos and the
            Inspiration block, tucked up under the hero's red-box overhang.
            The brighter #8000cb Inspiration card sits on top of it.
        -->
        <div class="relative z-0 -mt-[92px] px-5">
            <div
                class="mx-auto max-w-[1472px] rounded-b-[10px] bg-[#63009c] px-5 pt-[92px] sm:px-9"
            >
                <FeaturedLogos />
                <InspirationExperts
                    :lists="expertLists"
                    :tabs="expertListTabs"
                />
            </div>
        </div>

        <GiftingMadeSimple />
        <CtaPair />
        <UltimateHeroCloser />
    </div>
</template>
